'use client';
import { setCookie, getCookie } from 'cookies-next';

interface IImpression {
  item_list_location: string;
  item_list_id: string;
  type: 'hotel' | 'package' | 'flight' | 'tour' | 'ship';
}

export const productImpression = ({
  item_list_location,
  item_list_id,
  type = 'hotel',
}: IImpression) => {
  const data =
    getCookie('DataLayer') &&
    JSON.parse(getCookie('DataLayer')?.toString() || '');
  if (type === 'hotel')
    setCookie(
      'DataLayer',
      {
        ...data,
        hotel_item_list_location: item_list_location,
        hotel_item_list_id: item_list_id,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  if (type === 'package')
    setCookie(
      'DataLayer',
      {
        ...data,
        package_item_list_location: item_list_location,
        package_item_list_id: item_list_id,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  if (type === 'flight')
    setCookie(
      'DataLayer',
      {
        ...data,
        flight_item_list_location: item_list_location,
        flight_item_list_id: item_list_id,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  if (type === 'tour')
    setCookie(
      'DataLayer',
      {
        ...data,
        tour_item_list_location: item_list_location,
        tour_item_list_id: item_list_id,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
  if (type === 'ship')
    setCookie(
      'DataLayer',
      {
        ...data,
        ship_item_list_location: item_list_location,
        ship_item_list_id: item_list_id,
      },
      {
        expires: new Date(Date.now() + 60 * 60 * 1000),
      }
    );
};
